import script from "./AddUpdateWithRegion.vue?vue&type=script&setup=true&lang=js"
export * from "./AddUpdateWithRegion.vue?vue&type=script&setup=true&lang=js"

export default script